$(document).ready(function() {
  if ($('body').hasClass('in-penove')) {
    $('main li .text').each(function() {
      if ($(this).text().trim() === 'Latex') {
        $(this).closest('li').addClass('disable')
      }
    })

    $(
      '<li class="red col-xs-6 col-sm-6 col-lg-3 col-xl-3"><a href="/latexove/"><span class="image"><img src="https://cdn.myshoptet.com/usr/www.vyspimese.cz/user/categories/thumb/levne_matrace__matrace_levn__.png" alt="Latexové matrace"></span><span class="text">Latex</span></a></li><li class="col-xs-6 col-sm-6 col-lg-3 col-xl-3"><a href="/matrace-z-konskych-zini/"><span class="image"><img src="https://cdn.myshoptet.com/usr/www.vyspimese.cz/user/categories/thumb/konske-zine.png" alt="Matrace z koňských žíní"></span><span class="text">Matrace z koňských žíní</span></a></li><li class="col-xs-6 col-sm-6 col-lg-3 col-xl-3"><a href="/kokosove-matrace/"><span class="image"><img src="https://cdn.myshoptet.com/usr/www.vyspimese.cz/user/categories/thumb/kokos.png" alt="Kokosové matrace"></span><span class="text">Kokosové matrace</span></a></li>'
    ).insertBefore('main .subcategories li.specialOffer')
  }
})

$(document).ready(function() {
  if ($('body').hasClass('in-prodejna-matraci-ostrava')) {
    // bed
    $(
      '<div class="visualization__wrapper--detail product"><div class="bed__1"></div><div class="bed__2"></div><div class="bed__3"></div><div class="bed__4"></div><div class="bed__5"></div><div class="bed__6"></div><div class="bed__7"></div><div class="bed__8"></div><div class="bed__9"></div><div class="bed__10"></div><div class="bed__12"></div><div class="bed__13"></div><div class="bed__14"></div><div class="bed__15"></div></div><div class="visualization__wrapper--detail shop"><div class="bed__1"><span>1</span></div><div class="bed__2"><span>2</span></div><div class="bed__3"><span>3</span></div><div class="bed__4"><span>4</span></div><div class="bed__5"><span>5</span></div><div class="bed__6"><span>6</span></div><div class="bed__7"><span>7</span></div><div class="bed__8"><span>8</span></div><div class="bed__9"><span>9</span></div><div class="bed__10"><span>10</span></div><div class="bed__12"><span>12</span></div><div class="bed__13"><span>13</span></div><div class="bed__14"><span>14</span></div><div class="bed__15"><span>15</span></div></div>'
    ).appendTo('.visualization__wrapper')

    $('<div class="vchod"><span>Vchod</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="pokladna"><span>Pokladna</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="chranice-matrace"><span>Chrániče<br />matrací</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="povleceni"><span>Povlečení</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="prosteradla"><span>Prostřeradla</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="polstare"><span>Polštáře</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )

    $('.visualization__wrapper--detail.product .bed__1').load('/cache/p-ostrava-1/ #products')
    $('.visualization__wrapper--detail.product .bed__2').load('/cache/p-ostrava-2/ #products')
    $('.visualization__wrapper--detail.product .bed__3').load('/cache/p-ostrava-3/ #products')
    $('.visualization__wrapper--detail.product .bed__4').load('/cache/p-ostrava-4/ #products')
    $('.visualization__wrapper--detail.product .bed__5').load('/cache/p-ostrava-5/ #products')
    $('.visualization__wrapper--detail.product .bed__6').load('/cache/p-ostrava-6/ #products')
    $('.visualization__wrapper--detail.product .bed__7').load('/cache/p-ostrava-7/ #products')
    $('.visualization__wrapper--detail.product .bed__8').load('/cache/p-ostrava-8/ #products')
    $('.visualization__wrapper--detail.product .bed__9').load('/cache/p-ostrava-9/ #products')
    $('.visualization__wrapper--detail.product .bed__10').load('/cache/p-ostrava-10/ #products')
    $('.visualization__wrapper--detail.product .bed__11').load('/cache/p-ostrava-11/ #products')
    $('.visualization__wrapper--detail.product .bed__12').load('/cache/p-ostrava-12/ #products')
    $('.visualization__wrapper--detail.product .bed__13').load('/cache/p-ostrava-13/ #products')
    $('.visualization__wrapper--detail.product .bed__14').load('/cache/p-ostrava-14/ #products')
    $('.visualization__wrapper--detail.product .bed__15').load('/cache/p-ostrava-15/ #products')
  }

  if ($('body').hasClass('in-prodejna-ceskych-matraci-a-posteli-opava')) {
    // bed
    $(
      '<div class="visualization__wrapper--detail product"><div class="bed__1"></div><div class="bed__2"></div><div class="bed__3"></div><div class="bed__4"></div><div class="bed__5"></div><div class="bed__6"></div><div class="bed__7"></div><div class="bed__8"></div><div class="bed__9"></div><div class="bed__10"></div><div class="bed__11"></div><div class="bed__12"></div><div class="bed__13"></div><div class="bed__14"></div><div class="bed__15"></div></div><div class="visualization__wrapper--detail shop"><div class="bed__1"><span>1</span></div><div class="bed__2"><span>2</span></div><div class="bed__3"><span>3</span></div><div class="bed__4"><span>4</span></div><div class="bed__5"><span>5</span></div><div class="bed__6"><span>6</span></div><div class="bed__7"><span>7</span></div><div class="bed__8"><span>8</span></div><div class="bed__9"><span>9</span></div><div class="bed__10"><span>10</span></div><div class="bed__11"><span>11</span></div><div class="bed__12"><span>12</span></div><div class="bed__13"><span>13</span></div><div class="bed__14"><span>14</span></div><div class="bed__15"><span>15</span></div></div>'
    ).appendTo('.visualization__wrapper')

    $('<div class="vchod"><span>Vchod</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="pokladna"><span>Pokladna</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="chranice-matrace"><span>Chrániče<br />matrací</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="povleceni"><span>Povlečení</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="prosteradla"><span>Prostřeradla</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="polstare"><span>Polštáře</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )

    $('.visualization__wrapper--detail.product .bed__1').load('/cache/p-opava-1/ #products')
    $('.visualization__wrapper--detail.product .bed__2').load('/cache/p-opava-2/ #products')
    $('.visualization__wrapper--detail.product .bed__3').load('/cache/p-opava-3/ #products')
    $('.visualization__wrapper--detail.product .bed__4').load('/cache/p-opava-4/ #products')
    $('.visualization__wrapper--detail.product .bed__5').load('/cache/p-opava-5/ #products')
    $('.visualization__wrapper--detail.product .bed__6').load('/cache/p-opava-6/ #products')
    $('.visualization__wrapper--detail.product .bed__7').load('/cache/p-opava-7/ #products')
    $('.visualization__wrapper--detail.product .bed__8').load('/cache/p-opava-8/ #products')
    $('.visualization__wrapper--detail.product .bed__9').load('/cache/p-opava-9/ #products')
    $('.visualization__wrapper--detail.product .bed__10').load('/cache/p-opava-10/ #products')
    $('.visualization__wrapper--detail.product .bed__11').load('/cache/p-opava-11/ #products')
    $('.visualization__wrapper--detail.product .bed__12').load('/cache/p-opava-12/ #products')
    $('.visualization__wrapper--detail.product .bed__13').load('/cache/p-opava-13/ #products')
    $('.visualization__wrapper--detail.product .bed__14').load('/cache/p-opava-14/ #products')
    $('.visualization__wrapper--detail.product .bed__15').load('/cache/p-opava-15/ #products')
  }

  if ($('body').hasClass('in-prodejna-matraci-trinec')) {
    // bed
    $(
      '<div class="visualization__wrapper--detail product"><div class="bed__1"></div><div class="bed__2"></div><div class="bed__3"></div><div class="bed__4"></div><div class="bed__5"></div><div class="bed__6"></div><div class="bed__7"></div><div class="bed__8"></div><div class="bed__9"></div><div class="bed__12"></div><div class="bed__13"></div><div class="bed__14"></div></div><div class="visualization__wrapper--detail shop"><div class="bed__1"><span>1</span></div><div class="bed__2"><span>2</span></div><div class="bed__3"><span>3</span></div><div class="bed__4"><span>4</span></div><div class="bed__5"><span>5</span></div><div class="bed__6"><span>6</span></div><div class="bed__7"><span>7</span></div><div class="bed__8"><span>8</span></div><div class="bed__9"><span>9</span></div><div class="bed__12"><span>12</span></div><div class="bed__13"><span>13</span></div><div class="bed__14"><span>14</span></div></div>'
    ).appendTo('.visualization__wrapper')

    $('<div class="vchod"><span>Vchod</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="pokladna"><span>Pokladna</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="chranice-matrace"><span>Chrániče<br />matrací</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="povleceni"><span>Povlečení</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="prosteradla"><span>Prostřeradla</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="polstare"><span>Polštáře</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )

    $('.visualization__wrapper--detail.product .bed__1').load('/cache/p-trinec-1/ #products')
    $('.visualization__wrapper--detail.product .bed__2').load('/cache/p-trinec-2/ #products')
    $('.visualization__wrapper--detail.product .bed__3').load('/cache/p-trinec-3/ #products')
    $('.visualization__wrapper--detail.product .bed__4').load('/cache/p-trinec-4/ #products')
    $('.visualization__wrapper--detail.product .bed__5').load('/cache/p-trinec-5/ #products')
    $('.visualization__wrapper--detail.product .bed__6').load('/cache/p-trinec-6/ #products')
    $('.visualization__wrapper--detail.product .bed__7').load('/cache/p-trinec-7/ #products')
    $('.visualization__wrapper--detail.product .bed__8').load('/cache/p-trinec-8/ #products')
    $('.visualization__wrapper--detail.product .bed__9').load('/cache/p-trinec-9/ #products')
    $('.visualization__wrapper--detail.product .bed__12').load('/cache/p-trinec-12/ #products')
    $('.visualization__wrapper--detail.product .bed__13').load('/cache/p-trinec-13/ #products')
    $('.visualization__wrapper--detail.product .bed__14').load('/cache/p-trinec-14/ #products')
  }

  if ($('body').hasClass('in-prodejna')) {
    // bed
    $(
      '<div class="visualization__wrapper--detail product"><div class="bed__1"></div><div class="bed__2"></div><div class="bed__3"></div><div class="bed__4"></div><div class="bed__5"></div><div class="bed__6"></div><div class="bed__7"></div><div class="bed__8"></div><div class="bed__9"></div><div class="bed__10"></div><div class="bed__11"></div><div class="bed__12"></div><div class="bed__13"></div><div class="bed__14"></div><div class="bed__15"></div></div><div class="visualization__wrapper--detail shop"><div class="bed__1"><span>1</span></div><div class="bed__2"><span>2</span></div><div class="bed__3"><span>3</span></div><div class="bed__4"><span>4</span></div><div class="bed__5"><span>5</span></div><div class="bed__6"><span>6</span></div><div class="bed__7"><span>7</span></div><div class="bed__8"><span>8</span></div><div class="bed__9"><span>9</span></div><div class="bed__10"><span>10</span></div><div class="bed__11"><span>11</span></div><div class="bed__12"><span>12</span></div><div class="bed__13"><span>13</span></div></div>'
    ).appendTo('.visualization__wrapper')

    $('<div class="vchod"><span>Vchod</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="pokladna"><span>Pokladna</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="chranice-matrace"><span>Chrániče<br />matrací</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="povleceni"><span>Povlečení</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="prosteradla"><span>Prostřeradla</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )
    $('<div class="polstare"><span>Polštáře</span></div>').appendTo(
      '.visualization__wrapper--detail.shop'
    )

    $('.visualization__wrapper--detail.product .bed__1').load(
      '/cache/p-frydek-mistek-1/ #products'
    )
    $('.visualization__wrapper--detail.product .bed__2').load(
      '/cache/p-frydek-mistek-2/ #products'
    )
    $('.visualization__wrapper--detail.product .bed__3').load(
      '/cache/p-frydek-mistek-3/ #products'
    )
    $('.visualization__wrapper--detail.product .bed__4').load(
      '/cache/p-frydek-mistek-4/ #products'
    )
    $('.visualization__wrapper--detail.product .bed__5').load(
      '/cache/p-frydek-mistek-5/ #products'
    )
    $('.visualization__wrapper--detail.product .bed__6').load(
      '/cache/p-frydek-mistek-6/ #products'
    )
    $('.visualization__wrapper--detail.product .bed__7').load(
      '/cache/p-frydek-mistek-7/ #products'
    )
    $('.visualization__wrapper--detail.product .bed__8').load(
      '/cache/p-frydek-mistek-8/ #products'
    )
    $('.visualization__wrapper--detail.product .bed__9').load(
      '/cache/p-frydek-mistek-9/ #products'
    )
    $('.visualization__wrapper--detail.product .bed__10').load(
      '/cache/p-frydek-mistek-10/ #products'
    )
    $('.visualization__wrapper--detail.product .bed__11').load(
      '/cache/p-frydek-mistek-11/ #products'
    )
    $('.visualization__wrapper--detail.product .bed__12').load(
      '/cache/p-frydek-mistek-12/ #products'
    )
    $('.visualization__wrapper--detail.product .bed__13').load(
      '/cache/p-frydek-mistek-13/ #products'
    )
  }

  // Přiřadíme událost 'mouseenter' ke všem prvkům s třídou začínající na 'bed__' v rámci '.shop'
  $('.visualization__wrapper--detail.shop [class*="bed__"]').mouseenter(function() {
    // Zjistíme index aktivovaného prvku
    var index = $(this).index()

    // Odebereme třídu 'open' od všech prvků v '.product'
    $('.visualization__wrapper--detail.product [class*="bed__"]').removeClass('open')

    // Přidáme třídu 'open' k prvku s odpovídajícím indexem v '.product'
    $('.visualization__wrapper--detail.product')
      .find(`[class*="bed__"]:eq(${index})`)
      .addClass('open')
  })
})
